import {Component, OnDestroy, OnInit} from '@angular/core';
import {getAppThemeName, getCookie} from 'src/app/core/functions/common.function';
import {debounceTime, fromEvent, Subscription} from "rxjs";
import {DBIconModule, DBMenuModule} from "@db/db-core";
import {TranslateModule} from "@ngx-translate/core";
import {LanguageMenuComponent} from "../../language-menu/language-menu.component";
import {CommonModule} from "@angular/common";
import {DBHeaderModule} from "@db/db-components";

@Component({
  selector: 'db-app-header',
  templateUrl: './db.header.component.html',
  styleUrls: ['./db.header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DBHeaderModule,
    DBIconModule,
    DBMenuModule,
    TranslateModule,
    LanguageMenuComponent
  ]
})
export class DBHeaderComponent implements OnInit, OnDestroy {
  public width: number = window.innerWidth;
  private resizeSubscription?: Subscription;

  public getThemeName?: string;
  constructor(
  ) { }

  ngOnInit() {
    this.getThemeName = getAppThemeName();
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.width = window.innerWidth;
      });
  }

  ngOnDestroy() {
    this.resizeSubscription?.unsubscribe();
  }

  protected readonly sessionStorage = sessionStorage;
  protected readonly getAppThemeName = getAppThemeName;
  protected readonly getCookie = getCookie;
}
